import React from 'react';
import PropTypes from 'prop-types';

const _ = {
    find:       require('lodash/find'),
}

const Globals = require('../../../../../app/globals');
const Strings = require('../../../../../app/shared/Strings');

const ShortCourseInstanceStore = require('../../../stores/ShortCourseInstanceStore');
import ShortCoursePlayStore from '../../../stores/ShortCoursePlayStore';
import ProfileEdit from '../../account/ProfileEdit';
import VoiceOptions from './VoiceOptions';
import VoiceControls from './VoiceControls';

const FLOW_FOCI = ShortCoursePlayStore.FLOW_FOCI;

const propTypes = {
    playStore: PropTypes.object.isRequired,
    askToExitCourse: PropTypes.func,
    onClose: PropTypes.func,
    closeDisabled: PropTypes.bool,
    onStarClick: PropTypes.func,
    onStudentFeedback: PropTypes.func,
    onReviewButton: PropTypes.func,
    reviewingProgress: PropTypes.bool,
};

// This component is shown when playing a course 
class ShortCourseTopNav extends React.Component {
    constructor(props) {
        super(props);
        let storeState = this.getStoreState(props);
        this.state = {...storeState };
        this.unsubscribes = [this.props.playStore.getStore().listen(this.onPlayChange)];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getStoreState=(props)=>{
        let playStoreState = this.props.playStore.getStore().getState();
        let flowFocus = playStoreState.flowFocus;
        let node_id = playStoreState.node_id;
        let stars_out_of_three = null; // no display
        if (node_id) {
            let { gate, min_gate, max_gate, remediating }  = this.props.playStore.getNodeGateStatus(node_id);
            stars_out_of_three = (gate - 1);
        }
        let hasVoice = this.props.playStore.hasVoice();
        
        return { flowFocus, node_id, stars_out_of_three, hasVoice }
    }

    // FOR DEMO ONLY!!
    onReset=()=>{
        const doc = this.props.playStore.getDoc(); // shortCourseInstance
        if (window.confirm("Reset attempts? (Analytics will not be altered)")) {
            if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                const ShortCourseInstanceActions = require('../../../actions/ShortCourseInstanceActions');
                const uuid = require('uuid');
                const instanceHash = doc.hash;
                
                ShortCourseInstanceActions.resetShortCourseInstanceAttempts(uuid.v4(), {
                    instanceHash,
                    successCallback: ()=>{
                        console.log("refreshing page");
                        location.reload();
                    }
                });
            } // if not release
        } // if confirmed
    }

    onPlayChange=(storeState)=>{
        this.setState(this.getStoreState(this.props));
    }

    //exitWelcomeScreen=()=>{
    //    this.props.playStore.actions.goToRecommendedNode();
   // }
    
    returnToWelcomeScreen=()=>{
        this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.WelcomeScreen});
    }
    
    //returnToFlowMap=()=>{
    //    this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.FlowMap});
    //}

    goToRecommendationScreen=()=>{
        this.props.playStore.actions.goToRecommendedNode();
    }

    returnToNode=()=>{
        this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.SingleNode});
    }
    
    /*onAudioControls=()=>{
        let showAudioControls = this.state.showAudioControls ? false : true; // toggle
        this.setState({showAudioControls});
    }*/
    
    /*closeAudioControls=()=>{
        this.setState({showAudioControls:false});
    }*/
    
    onProfile=()=>{
        let showProfileEditor = this.state.showProfileEditor ? false : true; // toggle
        this.setState({showProfileEditor});
    }
    
    closeProfileEditor=()=>{
        this.setState({showProfileEditor: false});
    }
    
    onChangeAvatar=(params)=>{
        let {avatar_name,avatar_hash} = params;
        this.props.playStore.onUpdateAvatar({avatar_name,avatar_hash});
        this.setState({showProfileEditor: false});
    }
    
    onReviewProgress=()=>{
        if (this.props.onReviewButton) {
            this.props.onReviewButton();
        }
    }
    
    /*renderStars=()=>{
        var starArray = [];
        var filledStars = this.state.stars_out_of_three;
        for (var star=1; star<=3; ++star) {
            starArray.push(
                <i key={star} className={(filledStars >= star) ? "fa fa-star" : "fa fa-star-o"} aria-hidden="true"/>
            );
        }
        return (
            <div className="star-display" onClick={this.props.onStarClick}>
                {starArray}
            </div>
        );
    }*/

    render() {
        const doc = this.props.playStore.getDoc();
        const user = doc.user;
        const introScriptEntry = doc && doc.client_content && _.find(doc.client_content.coach_scripts,{id:'intro'});
        const hasWelcomeScreen = (introScriptEntry && introScriptEntry.actions.length) ? true : false;
        const askToExitCourse = this.props.askToExitCourse;
        const node = _.find(doc.nodes,{node_id: this.state.node_id});
        
        let homeFunction;
        let navTitle = doc.course_title;
        //let stars = null; // Almost always render stars #5811
        switch(this.state.flowFocus) {
            case FLOW_FOCI.ErrorScreen:
                navTitle = "Welcome";
                homeFunction = askToExitCourse;
                break;
            case FLOW_FOCI.WelcomeScreen:
                navTitle = "Welcome";
                homeFunction = askToExitCourse;
                break;
            case FLOW_FOCI.FlowMap: {
                if (hasWelcomeScreen) {
                    homeFunction = this.returnToWelcomeScreen;
                }
                else if (askToExitCourse) {
                    homeFunction = askToExitCourse;
                }
                //stars = this.renderStars();
                break;
            }
            case FLOW_FOCI.ActivityAttempt:
            case FLOW_FOCI.ContentBlockLink:
                if (node) {
                    navTitle = node.name;
                }
                //stars = this.renderStars();
                homeFunction = this.returnToNode;
                break;
            case FLOW_FOCI.SingleNode:
            {
                if (node) {
                    navTitle = node.name;
                }
                if (hasWelcomeScreen) {
                    homeFunction = this.returnToWelcomeScreen;
                }
                else if (askToExitCourse) {
                    homeFunction = askToExitCourse;
                }
                else {
                    homeFunction = this.returnToNode;
                }
                //stars = this.renderStars();
                break;
            }
            case FLOW_FOCI.AttemptCompleted:
            {
                if (node) {
                    navTitle = node.name;
                }
                homeFunction = this.goToRecommendationScreen;
                //stars = this.renderStars();
                break;
            }
            case FLOW_FOCI.CourseCompleted:
                navTitle = "Course Completed";
                homeFunction = askToExitCourse;
                //stars = this.renderStars();
                break;
            
            default:
                if (hasWelcomeScreen) {
                    homeFunction = this.returnToWelcomeScreen;
                }
                else {
                    homeFunction = this.returnToNode;
                }
                //stars = this.renderStars();
                // homeFunction = this.returnToFlowMap; // unexpected
        }
        if (this.props.playStore.currentAttempt) {
            homeFunction = null;
        }
        const isPreview = this.props.playStore.getIsPreview();
        const lowerEnvironment = (GlobalConfig.DebugMode || GlobalConfig.DevMode); // for DEMO reset button
        const disableProfileButton = this.state.showAudioControls; 
        const disableAudioControlsButton = this.state.showProfileEditor;
        const disableFeedbackButton = disableProfileButton || disableAudioControlsButton;
        
        return (
            <div className="short-course-nav-bar">
                <i className={"back-button fa fa-arrow-left" + (homeFunction ? "": " disabled")} title="back" aria-hidden="true" onClick={homeFunction}/>
                {/*stars*/}
                <div className="nav-text" onClick={this.props.onStarClick}>
                    <span className="course-name">{navTitle}</span>
                </div>

                <div className="btn-panel">
                    {/*<button className="help-button" onClick={this.onSettings}>
                        <span className="fa fa-question-circle-o"/>
                    </button>*/}
                    {/*this.state.hasVoice ? 
                    <button className="audio-controls-button" disabled={disableAudioControlsButton} onClick={this.onAudioControls}>
                        <span className="fa fa-cog"/>
                    </button>
                    : null */}
                    <button className="profile-button" disabled={disableProfileButton} onClick={this.onProfile}>
                        Profile
                    </button>

                    {this.props.onStudentFeedback ? 
                    <button className="feedback-button" disabled={disableFeedbackButton} onClick={this.props.onStudentFeedback} title="click here to send us your feedback!" >
                        Feedback
                    </button>
                    : null }

                    <button className={this.props.reviewingProgress ? "review-button active" : "review-button"} onClick={this.onReviewProgress}>
                        {Strings['en'].short_course.REVIEW_PROGRESS}
                    </button>


                    {(lowerEnvironment && !isPreview && !this.props.onClose) ? 
                    <button className="reset-button" onClick={this.onReset}>
                        <span className="fa fa-recycle"/>
                    </button> : null }
                    {this.props.onClose ? <button className="btn btn-light fr" onClick={this.props.onClose} disabled={this.props.closeDisabled}>Close</button> : null }
                </div>
                {this.state.showProfileEditor ? 
                <div className="profile-edit-wrapper">
                    <ProfileEdit user={user} onSave={this.onChangeAvatar} onClose={this.closeProfileEditor}/> 
                </div>
                : null }
                {/* this.state.showAudioControls ?
                <div className="audio-control-wrapper">
                    <VoiceOptions onClose={this.closeAudioControls}/>
                </div>
                : null */}
                { (this.state.hasVoice /*&& !this.props.playingActivity*/) ? 
                <div className="voice-control-wrapper">
                    <VoiceControls/> 
                </div>
                : null }
            </div>
        );
    }
} // ShortCourseTopNav

ShortCourseTopNav.propTypes = propTypes;

export default ShortCourseTopNav;